import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import { useTranslation } from '../../context/LanguageContext';
import { useLocalizedSettings } from '../../hooks/useLocalizedSettings';

/**
 * Home — Call-to-action banner with phone link.
 */
export const HomeCtaSection = () => {
    const { t } = useTranslation();
    const { phoneHref } = useLocalizedSettings();

    return (
        <section className="relative py-16 sm:py-20 bg-navy overflow-hidden">
            <div className="absolute inset-0 opacity-10" aria-hidden="true">
                <div className="absolute top-0 left-0 w-64 h-64 bg-gold rounded-full -translate-x-1/2 -translate-y-1/2" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-gold rounded-full translate-x-1/3 translate-y-1/3" />
            </div>
            <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">
                    {t('cta.title')}
                </h2>
                <p className="text-base sm:text-lg text-gray-300 mb-8 sm:mb-10 max-w-xl mx-auto">
                    {t('cta.subtitle')}
                </p>
                <a href={phoneHref}
                    className="inline-flex items-center space-x-3 px-10 py-4 bg-gold text-white font-bold rounded-full hover:bg-gold-dark transition-all shadow-lg hover:shadow-xl text-lg">
                    <FaPhoneAlt />
                    <span>{t('cta.button')}</span>
                </a>
            </div>
        </section>
    );
};

